'use client'

import BalanceFundingWalletSection from '@lyra/web/containers/home/BalanceFundingWalletSection'
import BalanceHeaderSection from '@lyra/web/containers/home/BalanceHeaderSection'
import HomeConnectPromptSection from '@lyra/web/containers/home/HomeConnectPromptSection'
import HomeFirstDepositPromptSection from '@lyra/web/containers/home/HomeFirstDepositPromptSection'
import HomeMarketsSection from '@lyra/web/containers/home/HomeMarketsSection'
import HomeTransferPromptSection from '@lyra/web/containers/home/HomeTransferPromptSection'
import HomeYieldSection from '@lyra/web/containers/home/HomeYieldSection'
import PendingTransactionsSection from '@lyra/web/containers/home/PendingTransactionsSection'
import useLyraFundingBalances from '@lyra/web/hooks/useLyraFundingBalances'
import useNewAccount from '@lyra/web/hooks/useNewAccount'
import useTransaction from '@lyra/web/hooks/useTransaction'
import React, { useMemo } from 'react'

import PositionsSection from '../../containers/common/PositionsSection'
import HomeAnnouncementsSection from '../../containers/home/HomeAnnouncementSection'

export default function HomePageHelper() {
  const { isNoAuth, isAuthWithNoFirstDeposit, isAuthWithNoFirstTransfer } = useNewAccount()
  const { pendingBridges } = useTransaction()
  const { fundingBalances } = useLyraFundingBalances()
  const hasFundingBalances = useMemo(() => {
    return Object.values(fundingBalances).some((bal) => bal.balance > 0)
  }, [fundingBalances])

  return (
    <>
      <BalanceHeaderSection isLarge noTopBorder isLink isAnimated />
      {pendingBridges.length ? <PendingTransactionsSection isLarge /> : null}
      {hasFundingBalances ? <BalanceFundingWalletSection isLarge /> : null}
      <HomeAnnouncementsSection isLarge />
      {isNoAuth ? (
        <HomeConnectPromptSection isLarge />
      ) : isAuthWithNoFirstDeposit ? (
        <HomeFirstDepositPromptSection isLarge />
      ) : isAuthWithNoFirstTransfer ? (
        <HomeTransferPromptSection isLarge />
      ) : (
        <PositionsSection isLarge showSubaccountSummary showSubaccountSwitch />
      )}
      <HomeMarketsSection isLarge />
      <HomeYieldSection isLarge />
    </>
  )
}
